import { describe, expect, it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages, { type Card, type Page } from '..';

describe('ShipTo Page Template Config', () => {
  it('exports one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const shipToPage = pages.find(p => p.route === PAGE_ROUTES.shipTo) as Page;

  describe('ShipTo Page Structure', () => {
    it('has correct route', () => {
      expect(shipToPage.route).toBe(PAGE_ROUTES.shipTo);
    });

    it('contains cards array', () => {
      expect(Array.isArray(shipToPage.cards)).toBe(true);
      expect(shipToPage.cards.length).toBeGreaterThan(0);
    });
  });

  describe('Card Validations', () => {
    it('contains address card with hideSameAs true', () => {
      const addressCard = shipToPage.cards.find(
        (c: Card) => c.key === CARD_CATEGORIES.address
      ) as Card;
      expect(addressCard).toBeDefined();
      expect(addressCard.hideSameAs).toBe(true);
      expect(addressCard.fields).toHaveLength(2);
    });

    it('contains deliveryDetails card with fields', () => {
      const deliveryDetails = shipToPage.cards.find(
        (c: Card) => c.key === CARD_CATEGORIES.deliveryDetails
      ) as Card;
      expect(deliveryDetails).toBeDefined();
      expect(deliveryDetails.fields!.length).toBeGreaterThan(0);
    });

    it('contains deliveryInstructions card', () => {
      const deliveryInstructions = shipToPage.cards.find(
        (c: Card) => c.key === CARD_CATEGORIES.deliveryInstructions
      ) as Card;
      expect(deliveryInstructions).toBeDefined();
      expect(deliveryInstructions.fields!.length).toBeGreaterThan(0);
    });

    it('coa card is required', () => {
      const coaCard = shipToPage.cards.find(
        (c: Card) => c.key === CARD_CATEGORIES.coa
      ) as Card;
      expect(coaCard.required).toBe(true);
    });

    it('packingList card is required and has sameAsFields', () => {
      const packingList = shipToPage.cards.find(
        (c: Card) => c.key === CARD_CATEGORIES.packingList
      ) as Card;
      expect(packingList.required).toBe(true);
      expect(Array.isArray(packingList.sameAsFields)).toBe(true);
      expect(packingList.sameAsFields!.length).toBeGreaterThan(0);
    });

    it('orderConfirmation card is required and has multiple sameAsFields', () => {
      const orderCard = shipToPage.cards.find(
        (c: Card) => c.key === CARD_CATEGORIES.orderConfirmation
      ) as Card;
      expect(orderCard.required).toBe(true);
      expect(orderCard.sameAsFields!.length).toBeGreaterThan(1);
    });

    it('contains additionalAttachment card', () => {
      const attachmentCard = shipToPage.cards.find(
        (c: Card) => c.key === CARD_CATEGORIES.additionalAttachmentCard
      ) as Card;
      expect(attachmentCard).toBeDefined();
      expect(attachmentCard.fields).toHaveLength(1);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = shipToPage.cards.find(
        (c: Card) => c.key === CARD_CATEGORIES.privacyPolicy
      ) as Card;
      expect(privacyCard).toBeDefined();
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});
